import React from 'react';
import './header.css'
import logo from '../../assets/logo.png'
import Navsheader from '../common/headernavs';
import music from '../../assets/music.mp3'
import pic2 from '../../assets/pic2.png'
import pic3 from '../../assets/pic3.png'
import { useState } from 'react';
import {Link} from 'react-router-dom'

const Header = () => {


      const [isPlaying, setIsPlaying] = useState(false);
const toggleSound = () => {
        const audio = document.getElementById("bg-music");

        if (isPlaying) {
            audio.pause();
            setIsPlaying(false);
        } else {
            audio.play();
            setIsPlaying(true);
        }
    };

    let soundImage;

    if (isPlaying) {
        soundImage = pic3;
    } else {
        soundImage = pic2;
    }
    return ( <header className='headerr'>
            <nav className='navs-header'>
                <img className='logo' src={logo} alt='logo'></img>


                <nav className='part2-header'>
                    <ul className='list-navs'>
                        <Link to='/' className='link'>
                            <Navsheader title='Home'  />
                        </Link>
                        <Navsheader title='About'  />
                        <Navsheader title='Fun Facts'  />
                    </ul>
                    <button className='sound-button' onClick={toggleSound}>
                             <img src={soundImage} alt="sound toggle" />
                    </button>
                    <audio id="bg-music" src={music} loop></audio>
                </nav>
            </nav>
    </header> );
}
 
export default Header;